import Button from '@carvana/ds-button';
import Spinner from '@carvana/ds-icons/Spinner1Cvna';
import { Image as ImageIcon } from 'lucide-react';
import { useCallback, useContext } from 'react';
import CarouselContext from '~/context/vdp/CarouselContext';
import { useAnalyticsId } from '~/context/vdp/SectionAnalyticsContext';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import useGalleryImages from '~/hooks/vdp/useGalleryImages';

export default function SpinnerButtons() {
  const analyticsId = useAnalyticsId();
  const { openFullScreenGallery } = useContext(CarouselContext);
  const { hasError, isSpinnerDisabled, openSpinnerView360 } =
    useContext(SpinnerContext);
  const images = useGalleryImages();
  const showSpinnerButtons = !hasError && !isSpinnerDisabled;

  const handleGalleryClick = useCallback(() => {
    if (images.length === 0) return;

    const firstImage = images[0];
    if (!firstImage.id || !firstImage.type) return;

    openFullScreenGallery(firstImage.id, firstImage.type);
  }, [images, openFullScreenGallery]);

  if (!showSpinnerButtons) return null;

  return (
    <div className="flex w-full gap-md md:gap-xl">
      <Button
        aria-label="360º view"
        className="pointer-events-auto flex flex-1 gap-md"
        data-adobe-id="360-view"
        data-analytics-id={analyticsId}
        data-analytics-attributes={JSON.stringify({
          description: '360 view'
        })}
        data-testid="spinner-360-view-button"
        onClick={openSpinnerView360}
        size="xs"
        utility
        variant="secondary"
        icon
      >
        <Spinner aria-hidden="true" size={16} />
        <span className="hidden t-label-sm md:block">360º view</span>
      </Button>
      <Button
        aria-label={`${images.length.toLocaleString()} photos`}
        className="pointer-events-auto flex flex-1 gap-md"
        data-adobe-id={`${images.length}-photos`}
        data-analytics-id={analyticsId}
        data-analytics-attributes={JSON.stringify({
          description: 'Gallery'
        })}
        data-testid="spinner-photos-button"
        onClick={handleGalleryClick}
        size="xs"
        utility
        variant="secondary"
        icon
      >
        <ImageIcon aria-hidden="true" size={16} />
        <span className="hidden t-label-sm md:block">
          {images.length.toLocaleString()} photos
        </span>
      </Button>
    </div>
  );
}
